(() => {
  'use strict';

  if (window.__mellerMobileInlineSearchBound) return;
  window.__mellerMobileInlineSearchBound = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let panel = null;
  let lastTrigger = null;

  const getModal = () => document.getElementById('search-modal');
  const getSourceInner = () => getModal()?.querySelector('.search-modal__inner');
  const getTriggers = () =>
    Array.from(document.querySelectorAll('[data-meller-search-action] .search-modal__button'));

  const ensureSearchStyles = () => {
    if (document.getElementById('meller-search-modal-style')) return;

    const template = document.getElementById('meller-search-modal-style-template');
    const templateStyle = template?.content?.querySelector('style');
    if (!templateStyle) return;

    const style = templateStyle.cloneNode(true);
    style.id = 'meller-search-modal-style';
    document.head.appendChild(style);
    template.remove();
  };

  const ensurePanel = () => {
    if (panel?.isConnected) return panel;

    panel = document.getElementById('meller-mobile-inline-search');

    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'meller-mobile-inline-search';
      panel.className = 'meller-mobile-inline-search search-modal__content';
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
    }

    const headerComponent = document.getElementById('header-component');
    const headerGroup = document.getElementById('header-group');

    if (headerComponent?.parentNode) {
      headerComponent.insertAdjacentElement('afterend', panel);
    } else if (headerGroup) {
      headerGroup.appendChild(panel);
    }

    return panel;
  };

  const setTriggerState = (expanded) => {
    getTriggers().forEach((trigger) => {
      trigger.setAttribute(
        'aria-controls',
        mobileQuery.matches ? 'meller-mobile-inline-search' : 'search-modal'
      );
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  };

  const buildInlineSearch = () => {
    const sourceInner = getSourceInner();
    if (!sourceInner) return null;

    const clone = sourceInner.cloneNode(true);
    clone.classList.add('meller-mobile-inline-search__inner');

    const input = clone.querySelector('.search-input');
    const label = clone.querySelector('label[for]');

    if (input) {
      input.id = 'meller-mobile-inline-search-input';
      input.placeholder = 'Buscar en nuestra tienda';
    }

    if (label) label.setAttribute('for', 'meller-mobile-inline-search-input');

    clone.querySelector('.predictive-search__close-modal-button')?.remove();

    return clone;
  };

  const closeInlineSearch = ({ restoreFocus = false } = {}) => {
    const inlinePanel = ensurePanel();

    inlinePanel.replaceChildren();
    inlinePanel.hidden = true;
    inlinePanel.setAttribute('aria-hidden', 'true');
    setTriggerState(false);

    if (restoreFocus && lastTrigger instanceof HTMLElement && lastTrigger.isConnected) {
      try {
        lastTrigger.focus({ preventScroll: true });
      } catch (_error) {
        lastTrigger.focus();
      }
    }
  };

  const openInlineSearch = (trigger) => {
    ensureSearchStyles();

    const inlinePanel = ensurePanel();
    const searchInner = buildInlineSearch();
    if (!searchInner) return;

    lastTrigger = trigger instanceof HTMLElement ? trigger : null;
    inlinePanel.replaceChildren(searchInner);
    inlinePanel.hidden = false;
    inlinePanel.setAttribute('aria-hidden', 'false');
    setTriggerState(true);

    if (typeof window.__mellerLoadPredictiveSearch === 'function') {
      window.__mellerLoadPredictiveSearch();
    }

    window.requestAnimationFrame(() => {
      const input = inlinePanel.querySelector('.search-input');
      if (!input) return;

      try {
        input.focus({ preventScroll: true });
      } catch (_error) {
        input.focus();
      }
    });
  };

  const isInlineOpen = () => {
    const inlinePanel = ensurePanel();
    return mobileQuery.matches && !inlinePanel.hidden && inlinePanel.childElementCount > 0;
  };

  const submitFullSearch = (button) => {
    const form = button?.closest('form');
    const input = form?.querySelector('input[name="q"]');

    if (!(form instanceof HTMLFormElement) || !(input instanceof HTMLInputElement)) return;

    if (!input.value.trim()) {
      try {
        input.focus({ preventScroll: true });
      } catch (_error) {
        input.focus();
      }
      return;
    }

    HTMLFormElement.prototype.submit.call(form);
  };

  const setup = () => {
    ensurePanel();
    setTriggerState(false);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  window.addEventListener(
    'click',
    (event) => {
      if (!mobileQuery.matches) return;

      const target = event.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest('[data-meller-search-action] .search-modal__button');

      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (isInlineOpen()) {
          closeInlineSearch({ restoreFocus: true });
        } else {
          openInlineSearch(trigger);
        }
        return;
      }

      const viewAllButton = target.closest(
        '#meller-mobile-inline-search .predictive-search__search-button'
      );

      if (viewAllButton && isInlineOpen()) {
        event.preventDefault();
        event.stopPropagation();
        submitFullSearch(viewAllButton);
        return;
      }

      if (isInlineOpen() && target.closest('.header__drawer, .header__icon--menu')) {
        closeInlineSearch();
      }
    },
    true
  );

  window.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Escape' || !isInlineOpen()) return;

      event.preventDefault();
      event.stopPropagation();
      closeInlineSearch({ restoreFocus: true });
    },
    true
  );

  const handleViewportChange = () => {
    if (panel?.isConnected && !panel.hidden) closeInlineSearch();
    setTriggerState(false);
  };

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', handleViewportChange);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(handleViewportChange);
  }

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', () => {
      panel = null;
      setup();
    });
  }
})();
